var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hourglass_disabled"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26122_232728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26122_232728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hourglass_disabled_2",
    d: "M20.4758 23.3L19.1758 22H4.00078V20H6.00078V17C6.00078 15.9833 6.23828 15.0292 6.71328 14.1375C7.18828 13.2458 7.85078 12.5333 8.70078 12C8.16745 11.6667 7.71328 11.2667 7.33828 10.8C6.96328 10.3333 6.65911 9.81667 6.42578 9.25L0.675781 3.5L2.10078 2.075L21.9008 21.875L20.4758 23.3ZM15.0508 12.15L13.5508 10.675C14.3008 10.3583 14.8966 9.86667 15.3383 9.2C15.7799 8.53333 16.0008 7.8 16.0008 7V4H8.00078V5.125L4.87578 2H20.0008V4H18.0008V7C18.0008 8.06667 17.7424 9.05833 17.2258 9.975C16.7091 10.8917 15.9841 11.6167 15.0508 12.15ZM8.00078 20H16.0008V18.825L10.4758 13.3C9.72578 13.6167 9.12578 14.1083 8.67578 14.775C8.22578 15.4417 8.00078 16.1833 8.00078 17V20Z",
    fill: "#CC0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.d2f81a098079cfdabda3b3f406fbe959.svg";
export { ForwardRef as ReactComponent };